namespace TabAurous.Sales {
    export namespace CategoryWiseSalesByPriceService {
        export const baseUrl = 'Sales/CategoryWiseSalesByPrice';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<SalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Sales/CategoryWiseSalesByPrice/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>CategoryWiseSalesByPriceService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
